import firebase from "firebase";
import axios from "axios";
import countries from "./countries.json";
const URL = "https://escuelapp-api-v2.azurewebsites.net/api/checkout";
async function config(user = firebase.auth().currentUser) {
  if (!user || user.isAnonymous) throw new Error("Inicia sesión para continuar con tu suscripción.");
  return { headers: { Authorization: "Bearer " + await user.getIdToken() }, timeout: 25000 };
}
export async function ensureCheckoutProfile(user) {
  return (await axios.post(URL + "/profile", {}, await config(user))).data;
}
export function billingDetails(values, email) {
  const selected = countries.find(country => country.name === values.country || country.code === values.country);
  return { email: values.email || email, name: values.name || "", phone: values.phone || "",
    city: values.city || "", country: selected ? selected.code : values.country || "", state: values.state || "",
    line1: values.line1 || "", line2: values.line2 || "", esCif: values.esCif || values.es_cif || "",
    postalCode: values.postalCode || values.postal_code || "" };
}
export async function createCheckout(data, billing) {
  const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
  const requestId = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
  // Identity and Stripe customer always come from the server, never from billing or login form fields.
  const { username, password, customer, ...checkout } = data;
  return axios.post(URL + "/sessions", { checkout, billing, requestId }, await config());
}
export async function completeCheckout(sessionId) {
  return (await axios.post(URL + "/complete", { sessionId }, await config())).data;
}
export function checkoutError(error) {
  return error.response && error.response.data && error.response.data.message || error.message || "No se ha podido confirmar la compra. Inténtalo de nuevo.";
}



// WEBPACK FOOTER //
// ./app/checkout.js